import React from "react";
import { PartnerCard } from "./ui/partner-card";
import { Box, Flex } from "@radix-ui/themes";
import { BlueField } from "./ui/blue-field";

export function NovaPoshta() {
  return (
    <PartnerCard
      logo={
        <img
          className="partner-logo"
          src="/Images/barometer/2025/massMediaLogos/nova-post-logo.png"
          alt="partner logo"
        />
      }
      heading="Експертний Галузевий партнер"
    >
      <Flex direction="column" gap="5">
        <p>
          <BlueField>Нова Пошта — лідер логістичного ринку,</BlueField> який
          забезпечує легку доставку кожному клієнту — до відділення, поштомату,
          за адресою
        </p>

        <p>
          1,5 млн + посилок та вантажів щодня доставляємо по Україні, 24 год
          середній час доставки між містами, є найшвидшою доставкою в Україні.
          Нова пошта має найбільш розгалужену в Україні мережу:{" "}
          <BlueField>14 тис відділень по Україні,</BlueField> 28 тис поштоматів
          по Україні, 110 терміналів та депо. Сьогодні компанія — один з
          найбільших роботодавців України, де працює понад{" "}
          <BlueField>30 000 співробітників</BlueField>
        </p>

        <Box>
          <Box mb="4">
            <p>Компанія Нова пошта дбає про своїх співробітників:</p>
          </Box>
          <ul className="advantages">
            <li>наймає лише офіційно</li>
            <li>вчасно досталяє заробітну плату на картку працівника</li>
            <li>підтримує у будь-якій ситуації</li>
            <li>
              забезпечує{" "}
              <BlueField>медичне страхування та страхування життя</BlueField>{" "}
              для всіх працівників
            </li>
          </ul>
        </Box>

        <p>
          Нова пошта — це компанія, де можна{" "}
          <BlueField>рости, розвиватися</BlueField> та реалізовуватися (приймає
          на роботу без досвіду, навчає та постійно підтримує на шляху
          зростання)
        </p>
      </Flex>
    </PartnerCard>
  );
}
